var render = function render(_c,_vm){return _c('p',{staticClass:"error--text text-center mt-4"},[_vm._v(_vm._s(_vm.parent.$t('errors.correct_fields')))])
}
var staticRenderFns = []

export { render, staticRenderFns }